// extracted by mini-css-extract-plugin
export var container = "_6z-0";
export var icon = "_6z-1";
export var text = "_6z-2";